import GenericErrorContent from './GenericErrorContent.component';

export default GenericErrorContent;
